import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import DropzoneComponent from "react-dropzone-component";
import cx from "classnames";
import withStyles from "isomorphic-style-loader/lib/withStyles";
import { FormattedMessage, injectIntl } from "react-intl";

import PhotosList from "../PhotosList";

import messages from "../../locale/messages";
import showToaster from "../../helpers/showToaster";
import { getSpecificConfig } from "../../helpers/getConfigValue";
import {
  createListPhotos,
  removeListPhotos,
} from "../../actions/manageListPhotos";

import PictureImage from "/public/SiteIcons/photoUpload.svg";
import PhotoInstuctionIcon from "/public/SiteImages/instructionPhotoNew.svg";
import s from "!isomorphic-style-loader!css-loader!./filepicker.css";

class PhotosUpload extends Component {
  static propTypes = {
    createListPhotos: PropTypes.func.isRequired,
    removeListPhotos: PropTypes.func.isRequired,
    listId: PropTypes.number.isRequired,
    placeholder: PropTypes.string,
  };

  constructor(props) {
    super(props);
    this.dropzone = null;
    this.state = {
      djsConfig: {
        dictDefaultMessage: "Drop files here to upload",
        addRemoveLinks: false,
        maxFilesize: 10,
        maxFiles: 20,
        acceptedFiles: "image/jpeg,image/png",
        hiddenInputContainer: ".dzInputContainer",
        previewsContainer: false,
        method: "post",
        autoProcessQueue: true,
        url: "/photos",
        headers: { "X-Requested-With": "XMLHttpRequest" },
      },
      maxSize: 10,
    };
  }

  async componentDidMount() {
    const { placeholder } = this.props;
    const siteData = await getSpecificConfig({ name: ["maxUploadSize"] });
    const maxSize = siteData?.maxUploadSize || 10;

    this.setState({
      maxSize,
      djsConfig: {
        dictDefaultMessage: placeholder || "Drop files here to upload",
        addRemoveLinks: false,
        maxFilesize: maxSize,
        maxFiles: 20,
        acceptedFiles: "image/jpeg,image/png",
        hiddenInputContainer: ".dzInputContainer",
        previewsContainer: false,
        method: "post",
        autoProcessQueue: true,
        url: "/photos",
        headers: { "X-Requested-With": "XMLHttpRequest" },
      },
    });

    const input = document.querySelector(".dz-hidden-input");
    if (input) {
      input.style.visibility = "visible";
      input.style.opacity = "0";
      input.style.height = "100%";
      input.style.width = "100%";
      input.style.cursor = "pointer";
    }
  }

  sending = (file, xhr, formData) => {
    console.log("Sending file to /photos:", {
      fileName: file.name,
      size: file.size,
      type: file.type,
    });
  };

  sendingmultiple = (files, xhr, formData) => {
    console.log(
      "Sending multiple files to /photos:",
      files.map((f) => f.name)
    );
  };

  // error = (file, message, xhr) => {
  //   console.error("Dropzone error:", {
  //     message,
  //     file: file.name,
  //     xhrStatus: xhr?.status,
  //     xhrResponse: xhr?.response,
  //   });
  //   showToaster({
  //     message:
  //       typeof message === "string"
  //         ? message
  //         : "Upload failed. Please try again.",
  //     toasterType: "error",
  //   });
  //   this.dropzone.removeFile(file);
  // };

  complete = (file) => {
    const { listId, createListPhotos } = this.props;
    const isOnline = typeof window !== "undefined" && window.navigator.onLine;

    if (!isOnline) {
      showToaster({ messageId: "offlineError", toasterType: "error" });
      this.dropzone.removeFile(file);
      return;
    }

    if (file && file.xhr) {
      try {
        const response = JSON.parse(file.xhr.response);
        if (response.error) {
          showToaster({
            message: response.error,
            toasterType: "error",
          });
          this.dropzone.removeFile(file);
          return;
        }
        const { files } = response;
        if (!files || !Array.isArray(files) || files.length === 0) {
          throw new Error("No valid files in response");
        }
        const fileName = files[0].filename;
        const fileType = files[0].mimetype;
        if (listId !== undefined) {
          console.log("Dispatching createListPhotos:", {
            listId,
            fileName,
            fileType,
          });
          createListPhotos(listId, fileName, fileType);
        }
      } catch (err) {
        console.error("Error parsing response:", err);
        // showToaster({
        //   message: "Upload error. Please try again.",
        //   toasterType: "error",
        // });
      }
      this.dropzone.removeFile(file);
    }
  };

  validateFile = (file) => {
    const { maxSize } = this.state;
    const maxBytes = maxSize * 1024 * 1024;

    if (file.size > maxBytes) {
      showToaster({
        message: `File too large! Max allowed is ${maxSize}MB.`,
        toasterType: "error",
      });
      this.dropzone.removeFile(file);
      return false;
    }

    const reader = new FileReader();
    reader.onloadend = () => {
      const arr = new Uint8Array(reader.result).subarray(0, 4); // first 4 bytes
      let header = "";
      arr.forEach((b) => {
        header += b.toString(16).padStart(2, "0");
      });

      let type;
      if (header.startsWith("ffd8")) {
        type = "image/jpeg";
      } else if (header.startsWith("89504e47")) {
        type = "image/png";
      } else {
        type = "unknown";
      }

      if (type === "unknown") {
        showToaster({ messageId: "invalidType", toasterType: "error" });
        file.accepted = false;
        this.dropzone.removeFile(file);
      }
    };
    reader.readAsArrayBuffer(file.slice(0, 4));
    return true;
  };

  render() {
    const { listId, maxUploadSize } = this.props;
    const { djsConfig } = this.state;

    const componentConfig = {
      iconFiletypes: [".jpg", ".jpeg", ".png"],
      postUrl: "/photos",
    };

    const eventHandlers = {
      init: (dz) => (this.dropzone = dz),
      sending: this.sending,
      sendingmultiple: this.sendingmultiple,
      complete: this.complete,
      error: this.error,
      addedfile: this.validateFile,
    };

    return (
      <div className={cx("listPhotoContainer")}>
        <div
          className={cx("uploadInstructions")}
          style={{ marginBottom: "15px" }}
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "10px",
              marginBottom: "10px",
              fontSize: "16px",
              fontWeight: "500",
              color: "var(--menu-color)",
            }}
          >
            <img
              src={PhotoInstuctionIcon}
              alt="Instruction Icon"
              style={{ width: "24px", height: "24px" }}
            />
            <FormattedMessage {...messages.photosInstruction} />
          </div>

          <ul style={{ paddingLeft: "20px", color: "var(--menu-color)" }}>
            <li>
              <FormattedMessage {...messages.photosInstructionOne} />
            </li>
            <li>
              <FormattedMessage {...messages.photosInstructionTwo} />
            </li>
            <li>
              <FormattedMessage {...messages.photosInstructionThree} />
            </li>
            <li>
              <FormattedMessage {...messages.photosInstructionFive} />
            </li>
            <li>
              <FormattedMessage {...messages.photosInstructionSix} />
            </li>
          </ul>
        </div>
        <div className={cx("dzInputContainer", "svgImg")}>
          <DropzoneComponent
            config={componentConfig}
            eventHandlers={eventHandlers}
            djsConfig={djsConfig}
          >
            <img
              src={PictureImage}
              className={"photoUploadImg"}
              alt="PictureImage"
            />
          </DropzoneComponent>
        </div>
        <div className={"uploadSizeCss"}>
          <FormattedMessage {...messages.uploadSizedLabel} /> {maxUploadSize}MB
        </div>
        <PhotosList listId={listId} />
      </div>
    );
  }
}

const mapState = (state) => ({
  maxUploadSize: state?.siteSettings?.data?.maxUploadSize,
});

const mapDispatch = {
  createListPhotos,
  removeListPhotos,
};

export default injectIntl(
  withStyles(s)(connect(mapState, mapDispatch)(PhotosUpload))
);
